export default {
  title: 'Orari di apertura e posizione',
  set_different_opening_hours: 'Imposta orari di apertura diversi per la consegna',
  delivery_opening_hours: 'Orari di apertura per la consegna',
  sections: {
    general: 'Orari generali',
    holidays: 'Metti in pausa gli ordini (festività)',
    create_time: 'Aggiungi orario di apertura',
    edit_time: 'Modifica orario',
    delivery_schedule: 'Orari di apertura consegna',
  },
  tabs: {
    open_times: 'Orari di apertura',
    location: 'Posizione',
  },
  form: {
    select_all: {
      label: 'Seleziona tutti i giorni',
    },
    holiday_starts_at: {
      label: 'Data di inizio',
    },
    holiday_ends_at: {
      label: 'Data di fine',
    },
    has_delivery_schedule: {
      label: 'Imposta orari di apertura diversi per la consegna',
    },
    has_multiple_locations: {
      label: 'Imposta posizioni diverse per la settimana',
    },
  },
  labels: {
    day_location: '{{day}} posizione {{index}}',
    selected_days: 'Giorni selezionati',
    orders_paused: 'Ordini in pausa',
    open_time: 'Orario di apertura',
    close_time: 'Orario di chiusura',
  },
  errors: {
    close_time: "L'orario di chiusura non può essere 00:00. Inserisci 23:59",
  },
  buttons: {
    edit: 'Modifica',
    add_schedule_unit: 'Aggiungi orario di apertura',
    add_holiday: 'Aggiungi festività',
    delete: 'Elimina',
    save: 'Salva',
    cancel: 'Annulla',
  },
  toasts: {
    changes_got_saved: 'Informazioni aggiornate con successo',
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
  },
};
